import React, { useEffect, useState } from 'react';
import './greeting.css';
import SquareButton from '../../components/squareButton/squareButton';
import GreetingCarousel from '../../components/greetingCarousel/greetingCarousel';
import Carousel from 'react-bootstrap/Carousel';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Subscribe from '../../components/klaviyo/subscribe/subscribe';
import CircleButton from '../../components/circleButton/circleButton';
import { useNavigate } from 'react-router-dom';
import { useLazyGetComponentsQuery } from '../../redux/services/tanProfilesApi';
import { setProfileMeta } from '../../redux/slice/tanProfileSlice';
import { slice_map } from '../../components/componentMap/componentMap';
import PopoverScoller from '../../components/popoverScroller/popoverScroller';
import frontImage from "../../assets/images/Frame-5.png";
import backImage from "../../assets/images/Frame-6.png";
import orang from "../../assets/images/realorang.png"
import ladyface from "../../assets/images/ladyface.png"
import clonk from "../../assets/images/clonk.png"
import facebookImg from "../../assets/images/icons/newFB.png"
import instaImg from "../../assets/images/icons/newInsta.png"
import whiteLogo from "../../assets/images/MysticTan_Unity_Logo_White.png"
function Greeting() {
    // return(<>test</>)
    const [getComponents, { isLoading, isSuccess, isError }] = useLazyGetComponentsQuery();
    const mappedComponents = useSelector((state) => state?.tanProfile?.mappedComponents);
    const user = useSelector((state) => state?.auth?.user);
    const dispatch = useDispatch();
    const [showPopover, setShowPopover] = useState(false)
    const [scroll, setScroll] = useState(false)
    const { t } = useTranslation("translation", { keyPrefix: "greeting" });

    const popoverStances = [
        <div className='popover-stances position-one'>
            <h3>{t("popoverStance.title1", "Position 1")}</h3>
            <img src={frontImage}></img>
            <h3>{t("popoverStance.word1", "Place palms out towards the walls - Keep arms slightly forward in front of you")}</h3>
        </div>,
        <div className='popover-stances position-two'>
            <h3>{t("popoverStance.title2", "Position 2")}</h3>
            <img src={backImage}></img>
            <h3>{t("popoverStance.word2", "Extend arms straight out towards the walls and create a loose fist with both hands")}</h3>
        </div>,

    ]

    const popoverMyths = [
        <div className='myth-one'>
            <div className='popover-myths'>
                <img src={orang} className='scroll-image'></img>
                <h1>{t("popoverMythOne.h1", "Myth: Spray tanning will turn me orange")}</h1>
                <h3>{t("popoverMythOne.text", "Actual: Mystic Tan provides the most natural tan results, every time! We’ve put years of research and testing behind our proprietary spray tan solutions to ensure we deliver a flawless, streak free glow for all skin tones. In fact, 96% of tanners* described a Mystic Tan Unity tan as natural when compared to a suntan.")}</h3>
                <p>{t("popoverMythOne.smol", "*Results from in-salon field test survey of 200+ tanners")} </p>
            </div>
        </div>,
        <div className='myth-two'>
            <div className='popover-myths'>
                <img src={clonk} className='scroll-image'></img>
                <h1>{t("popoverMythTwo.h1", "Myth: Spray tans take too long")}</h1>
                <h3>{t("popoverMythTwo.text", "Actual: We get it, your time is precious! Unity was created to be quick and easy, so your spray tan can always fit into your on-the-go lifestyle without compromising the results you want. Sessions can be completed in under 4 minutes! ")}</h3>
            </div>
        </div>,
        <div className='myth-three'>
            <div className='popover-myths'>
                <img src={ladyface} className='scroll-image'></img>
                <h1>{t("popoverMythThree.h1", "Myth: It’s not for my skin tone")}</h1>
                <h3>{t("popoverMythThree.text", "Actual: There are many misconceptions about who needs a spray tan! The truth is, all skin benefits from the healthy glow that a spray tan can provide. Plus, there are benefits besides getting darker, like evening your complexion and accentuating your muscle tone. Don’t forget, Unity features 12 shades from subtle glow to deep bronze results!  ")}</h3>
            </div>
        </div>,
    ]
    const letsGo = useNavigate();//
    let name = user?.firstname || "friend"
    useEffect(() => {

        getComponents()
    }, [])
    return (
        <>
            <PopoverScoller show={showPopover} scroll={scroll} carouselEntries={showPopover ? showPopover : []} onHide={() => {
                setShowPopover(false)
                setScroll(false)
            }} />
            <div className='greeting-div'>
                <div class="greeting-container container-one">
                    <div class="text-right">
                        {t("welcome.hello", "Hi, ")}{name}!
                    </div>
                    <SquareButton className="button-left greeting-button" onClick={() => {
                        letsGo("/scanner")
                    }}>
                        <div className='button-text'>{t("start.new", "Start a new session")}</div>
                        {/* <div className='button-text'>{t("start.session", "Tanning session")}</div> */}
                    </SquareButton>
                </div>
                <div className='carousel-container'>
                    <div className='carousel-container-text'>
                        {t("sprayTanGuide", "Spray Tan Guide").toUpperCase()}
                    </div>
                    <GreetingCarousel itemOptions={[
                        {
                            text: t("itemOptions.stances", "Spray tan"),
                            text2: t("itemOptions.stances2", "stances"),
                            onClick: () => { setShowPopover(popoverStances) }
                        },
                        {
                            text: t("itemOptions.tancare", "Pre & post"),
                            text2: t("itemOptions.tancare2", "tan care"),
                            onClick: () => { letsGo("/instructions/video/XRT1OIPeAJw") }
                        },
                        {
                            text: t("itemOptions.guide", "Spray tan"),
                            text2: t("itemOptions.guide2", "guide"),
                            onClick: () => { letsGo("/instructions/video/QF6sRNKvDiQ") }
                        },
                        {
                            text: t("itemOptions.barrier", "How to apply"),
                            text2: t("itemOptions.barrier2", "barrier cream"),
                            onClick: () => { letsGo("/instructions/video/ev6VxuiRw60") }
                        },
                        // {
                        //     text: t("itemOptions.number", "What's your"),
                        //     text2: t("itemOptions.number2", "tan number"), //heh
                        //     onClick: () => { alert("Coming soon!") }
                        // },
                        {
                            text: t("itemOptions.myths", "Spray tan"),
                            text2: t("itemOptions.myths2", "myths"),
                            onClick: () => {
                                setScroll(true)
                                setShowPopover(popoverMyths)
                            }
                        },
                        // {
                        //     text: t("itemOptions.magnetan", "Magnetan"),
                        //     text2: t("itemOptions.magnetan2", "technology™"),
                        //     onClick: () => { alert("Coming soon!") }
                        // },
                        // {
                        //     text: t("itemOptions.wellfit", "WellFit"),
                        //     text2: t("itemOptions.wellfit2", "Skincare"),
                        //     // color: "var(--wellfit-balance-green)", //force css var color
                        //     onClick: () => { alert("Coming soon!") }
                        // },

                    ]} />
                </div>
                <div class="greeting-container container-two"></div>
                <div className="full-button-container tryon-button-container">
                    <SquareButton className="full-button" onClick={() => {
                        // dispatch(setProfileMeta({ profileType: "new", options: slice_map(mappedComponents) }))
                        letsGo("/fullscreenFilter");
                    }}>
                        {t("carousel.tryon", "Spray tan try on")}
                    </SquareButton>
                </div>
                <Carousel
                    className='image-carousel'
                    data-bs-theme="dark">
                    <Carousel.Item className=''>
                        <div className='image-carousel-item'>
                            <div className='image-carousel-image' onClick={() => { window.open("https://sunless.com/pages/salon-locator", '_blank', "noopener,noreferrer") }}>
                                {t("carousel.findLocation", "Find a Salon")}
                            </div>
                            <div className='image-carousel-image' onClick={() => {
                                letsGo("/history")
                            }}>
                                {t("carousel.history", "Your spray tan history")}
                            </div>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item className=''>
                        <div className='image-carousel-item'>
                            <div className='image-carousel-image' onClick={() => { letsGo(`/tanProfiles`); }}>
                                {t("carousel.tanProfiles", "Tan Profiles")}
                            </div>
                        </div>
                    </Carousel.Item>
                </Carousel>
                <div className="greeting-quicklinks">
                    <div className="greeting-quicklink" onClick={() => { window.open("https://sunless.com/pages/salon-locator", '_blank', "noopener,noreferrer") }}>
                        {t("carousel.findLocation", "Find a Salon")}
                    </div>
                    <div className="greeting-quicklink" onClick={() => { letsGo("/history") }}>
                        {t("carousel.history", "Your spray tan history")}
                    </div>
                    <div className="greeting-quicklink" onClick={() => { letsGo("/tanProfiles") }}>
                        {t("carousel.tanProfiles", "Tan Profiles")}
                    </div>
                </div>
                <div class="greeting-container container-three"></div>
                <div className="full-button-container quiz-button-container">
                    <SquareButton className="full-button" onClick={() => letsGo("/quiz")}>
                        {t("carousel.buildTan", "Build a Custom Glow Quiz")}
                    </SquareButton>
                </div>
                <div class="greeting-container container-footer">
                    <div class="footer-header">
                        <div className='icon-header'>
                            {/* {t("footerheader.unity", "Unity")} */}
                            <img src={whiteLogo}></img>
                        </div>
                        <div className='icon-buttons'>
                            <img onClick={() => { window.open("https://www.instagram.com/mystictanofficial/", '_blank', "noopener,noreferrer") }} src={instaImg}></img>
                            <img onClick={() => { window.open("https://www.facebook.com/MysticTan", '_blank', "noopener,noreferrer") }} src={facebookImg}></img>
                        </div>
                    </div>
                    <div className="footer-links">
                        {/* <a onClick={() => letsGo("/")}>{t("footerlink.about", "About")}</a> */}
                        <a onClick={() => { window.open("https://sunless.com/pages/salon-locator", '_blank', "noopener,noreferrer") }}>{t("footerlink.findlocation", "Find a Salon")}</a>
                        <a onClick={() => { window.open("https://sunless.com/", '_blank', "noopener,noreferrer") }}>{t("footerlink.shop", "VISIT OUR WEBSITE")}</a>
                    </div>
                    <div className='footer-slogan'>{t("footerslogan.words", "The future is customizeable.")}</div>
                    {/* <Subscribe /> */}
                </div>
            </div>
        </>
    );
}

export default Greeting;
